import { gql } from '@/service/gql'
import { type ResultOf } from 'gql.tada'

// language=GraphQL
export const imageFieldsFrag = gql(`
    fragment imageFields on Image @_unmask {
        width
        height
        url
        imageType
    }
`)

export type ImageFields = ResultOf<typeof imageFieldsFrag>
